import {
  ApplyVoucherProps,
  CollectionOrder,
  CreatedOrder,
  DeliveryOrder,
  PreviousOrderDm,
  Result,
  SubmitOrderProps,
  SubmitOrderResponseDm,
  SubmitPayPalOrderProps,
  SubmitPayStripeOrderProps,
  VoucherBasketItemDm,
} from '../Api';
import axios, { AxiosRequestConfig, throwIfServerError } from './apiServices';

const refererUrl = window.location.origin + window.location.pathname;

type OrderProps = {
  orderId: number | string;
};

export const get = async (props: OrderProps, config?: AxiosRequestConfig) => {
  try {
    const result = await axios.get<Result<PreviousOrderDm>>(`/order/order`, {
      params: props,
      ...(config || {}),
    });

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};

export const create = async (
  orderPayload: CollectionOrder | DeliveryOrder,
  config?: AxiosRequestConfig,
) => {
  try {
    const result = await axios.post<Result<CreatedOrder>>(
      '/order/order',
      orderPayload,
      config,
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};

export const submit = async (
  payload: SubmitOrderProps,
  config?: AxiosRequestConfig,
) => {
  try {
    const updatedPayload = {
      ...payload,
      refererUrl,
    };
    const result = await axios.post<Result<SubmitOrderResponseDm>>(
      '/order/SubmitOrder',
      updatedPayload,
      config,
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};

export const submitPayPal = async (
  payload: SubmitPayPalOrderProps,
  config?: AxiosRequestConfig,
) => {
  try {
    const updatedPayload = {
      ...payload,
      refererUrl,
    };

    const result = await axios.post<Result<SubmitOrderResponseDm>>(
      '/order/SubmitOrderPayPal',
      updatedPayload,
      config,
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};

export const submitPayStripe = async (
  payload: SubmitPayStripeOrderProps,
  config?: AxiosRequestConfig,
) => {
  try {
    const updatedPayload = {
      ...payload,
      refererUrl,
    };

    const result = await axios.post<Result<SubmitOrderResponseDm>>(
      '/order/SubmitOrderPayButton',
      updatedPayload,
      config,
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};

export const cancel = async (
  payload: OrderProps,
  config?: AxiosRequestConfig,
) => {
  try {
    await axios.post<Result<void>>('/order/CancelOrder', payload, config);
  } catch (error) {
    throwIfServerError(error);
  }
};

export const rate = async (
  payload: { orderId: number; rating?: 0 | 1 | 2 },
  config?: AxiosRequestConfig,
) => {
  try {
    await axios.post<Result<void>>('/order/RateOrder', payload, config);
  } catch (error) {
    throwIfServerError(error);
  }
};

export const applyVoucher = async (
  payload: ApplyVoucherProps,
  config?: AxiosRequestConfig,
) => {
  try {
    const result = await axios.post<Result<VoucherBasketItemDm[]>>(
      '/order/ApplyVoucherCodeToOrder',
      payload,
      config,
    );

    return result.data.Data;
  } catch (error) {
    throwIfServerError(error);
  }
};
